export const ROUTER = {
  DASHBOARD: () => '/',
  FULFILLMENT: () => '/fulfillment',
  AGGREGATOR: () => '/aggregator',
  WALLET: () => '/wallet',
  REPORT: () => '/report',
  PRODUCT_GROUP: () => '/product-group',
  PRODUCT_MANAGEMENT: () => '/product-management',
  VOUCHER_PIN_IMPORT: () => '/voucher-pin-import',
} as const;
